<div class="setup-totp">
  <div class="card">
    @if (mfa$ | async; as mfa) {
    <form
      class="k-form k-form-md"
      [formGroup]="mfaForm"
      (ngSubmit)="setupMfa()"
    >
      <div class="form-field">
        <div class="top">
          <span class="title"><b>MFA - AutoForm Cloud</b></span>
        </div>
        <div class="login-box">
          <div class="login-items">
            <div class="step">
              {{ "SETUP-TOTP.SCAN-STEP" | translate }}
            </div>
            <kendo-qrcode [value]="mfa.qrValue" errorCorrection="M" #qrCode>
            </kendo-qrcode>
            <div class="step">
              {{ "SETUP-TOTP.MANUAL-CODE-STEP" | translate }}
            </div>
            <div class="manual-code">{{ mfa.manualCode }}</div>
            <div class="step">
              {{ "SETUP-TOTP.ENTER-TOTP-STEP" | translate }}
            </div>
            <kendo-formfield class="code-input">
              <kendo-textbox formControlName="code" #code> </kendo-textbox>
            </kendo-formfield>
            @if(errorMessage) {
            <af-form-error
              class="form-error"
              [message]="errorMessage | translate"
            ></af-form-error>
            }
            <div class="k-form-buttons">
              <button kendoButton>{{ "ACTIONS.SUBMIT" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    }
  </div>
</div>
